var map = {
	"./img01.jpeg": "0e72",
	"./img02.jpeg": "187d",
	"./img03.jpeg": "1709",
	"./img04.jpeg": "9e09",
	"./img05.jpeg": "b433",
	"./img06.jpeg": "bd05",
	"./img07.jpeg": "baea"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c949";